/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var id     = 'pClear',
    Page   = require('stb-component-page'),
    page   = new Page({$node: document.getElementById(id)}),
    Panel = require('stb-component-panel'),
    app    = require('mag-app'),
    keys   = require('stb-keys'),

    //
    panel;


panel = new Panel({
    focusable: true
});


page.add(panel);
page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.ok:
            app.route(app.pages.main);
            break;
        case keys.back:
            app.currentIntent.close();
            app.emit('close');
            break;
    }
});


page.addListener('show', function () {
    debug.log('p clear ---->', 'green');
    panel.focus();
});

module.exports = page;
